let client

export function setClient(newClient) {
  client = newClient
}

// Request helpers
const reqMethods = [
  'request',
  'delete',
  'get',
  'head',
  'options', // url, config
  'post',
  'put',
  'patch', // url, data, config
  '$get',
  '$put',
  '$delete',
  '$post',
]

const service = {}

reqMethods.forEach((method) => {
  service[method] = (...rest) => {
    if (!client) {
      throw new Error('apiClient not installed')
    }
    const actualMethod = method.startsWith('$') ? method.slice(1) : method
    if (!client[actualMethod]) {
      throw new Error(`Method ${actualMethod} not found on client`)
    }
    return client[actualMethod].apply(null, rest)
  }
})
export const GET = service.get
export const POST = service.post
export const DELETE = service.delete
export const PUT = service.put

export default service
